
// // src/hooks/useResidentProfile.js
// import { useEffect, useMemo, useState, useCallback } from "react";
// import { doc, onSnapshot, updateDoc } from "firebase/firestore";
// import { getAuth, onAuthStateChanged, signInWithEmailAndPassword, updatePassword } from "firebase/auth";
// import { db } from "../firebase";

// // Change this if residents are stored under /residents/{uid}
// const RESIDENTS_COLLECTION = "users";

// const emptyAddress = { line1: "", line2: "", city: "", state: "", zip: "" };

// function computeAgeFromDOB(dobStr) {
//   if (!dobStr) return undefined;
//   const dob = new Date(dobStr);
//   if (Number.isNaN(dob.getTime())) return undefined;
//   const today = new Date();
//   let age = today.getFullYear() - dob.getFullYear();
//   const m = today.getMonth() - dob.getMonth();
//   if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) age--;
//   return age;
// }

// export function useResidentProfile({ collection = RESIDENTS_COLLECTION } = {}) {
//   const auth = useMemo(() => getAuth(), []);
//   const [currentUser, setCurrentUser] = useState(null);

//   const [loading, setLoading] = useState(true);
//   const [saving, setSaving] = useState(false);
//   const [error, setError] = useState("");

//   const [mobile, setMobile] = useState("");
//   const [address, setAddress] = useState(emptyAddress);
//   const [family, setFamily] = useState([]);

//   // Track auth state
//   useEffect(() => {
//     const unsub = onAuthStateChanged(auth, (u) => setCurrentUser(u || null));
//     return () => unsub();
//   }, [auth]);

//   // Firestore ref
//   const userRef = useMemo(() => {
//     const uid = currentUser?.uid;
//     return uid ? doc(db, collection, uid) : null;
//   }, [currentUser, collection]);

//   // Subscribe to user profile
//   useEffect(() => {
//     if (!userRef) {
//       setLoading(false);
//       return;
//     }
//     setLoading(true);
//     setError("");

//     const unsub = onSnapshot(
//       userRef,
//       (snap) => {
//         const data = snap.data() || {};
//         setMobile(data?.profile?.mobile || data?.phone || "");
//         setAddress({
//           line1: data?.profile?.address?.line1 || "",
//           line2: data?.profile?.address?.line2 || "",
//           city:  data?.profile?.address?.city  || "",
//           state: data?.profile?.address?.state || "",
//           zip:   data?.profile?.address?.zip   || "",
//         });
//         // Family might already exist without dob/age—handle gracefully
//         const fam = Array.isArray(data?.family) ? data.family : [];
//         setFamily(fam);
//         setLoading(false);
//       },
//       (err) => {
//         console.error("useResidentProfile snapshot error:", err);
//         setError(err?.message || "Failed to load profile.");
//         setLoading(false);
//       }
//     );
//     return () => unsub();
//   }, [userRef]);

//   // Save contact/address
//   const saveContactAddress = useCallback(async () => {
//     if (!userRef) return;
//     setSaving(true);
//     setError("");
//     try {
//       await updateDoc(userRef, {
//         "profile.mobile": mobile,
//         "profile.address": {
//           line1: address.line1?.trim() || "",
//           line2: address.line2?.trim() || "",
//           city:  address.city?.trim()  || "",
//           state: address.state?.trim() || "",
//           zip:   address.zip?.trim()   || "",
//         },
//       });
//     } catch (err) {
//       console.error("saveContactAddress error:", err);
//       setError(err?.message || "Failed to save contact & address.");
//     } finally {
//       setSaving(false);
//     }
//   }, [userRef, mobile, address]);

//   // Add family member (now with dob/age)
//   const addFamilyMember = useCallback(
//     async (name, relationship, dob, ageInput) => {
//       if (!userRef) return;
//       if (!name?.trim() || !relationship?.trim()) {
//         setError("Please provide both name and relationship.");
//         return;
//       }
//       // Compute age if dob provided; otherwise use manual age (if valid)
//       const computedAge = dob ? computeAgeFromDOB(dob) : undefined;
//       const finalAge = computedAge ?? (Number.isFinite(Number(ageInput)) ? Number(ageInput) : undefined);

//       setSaving(true);
//       setError("");
//       try {
//         const id = `${Date.now()}-${Math.random().toString(16).slice(2)}`;
//         const next = [
//           ...family,
//           {
//             id,
//             name: name.trim(),
//             relationship: relationship.trim(),
//             ...(dob ? { dob } : {}),        // store as 'YYYY-MM-DD'
//             ...(finalAge ? { age: finalAge } : {}),
//           },
//         ];
//         await updateDoc(userRef, { family: next });
//         setFamily(next);
//       } catch (err) {
//         console.error("addFamilyMember error:", err);
//         setError(err?.message || "Failed to add family member.");
//       } finally {
//         setSaving(false);
//       }
//     },
//     [userRef, family]
//   );

//   // Remove family member
//   const removeFamilyMember = useCallback(
//     async (id) => {
//       if (!userRef) return;
//       setSaving(true);
//       setError("");
//       try {
//         const next = family.filter((m) => m.id !== id);
//         await updateDoc(userRef, { family: next });
//         setFamily(next);
//       } catch (err) {
//         console.error("removeFamilyMember error:", err);
//         setError(err?.message || "Failed to remove family member.");
//       } finally {
//         setSaving(false);
//       }
//     },
//     [userRef, family]
//   );

//   // Change password (reauth required)
//   const changePassword = useCallback(
//     async (currentPwd, newPwd) => {
//       if (!currentUser?.email) {
//         throw new Error("Your account has no email; password change not available.");
//       }
//       if (!currentPwd || !newPwd) {
//         throw new Error("Please enter current and new password.");
//       }
//       if (newPwd.length < 6) {
//         throw new Error("New password must be at least 6 characters.");
//       }
//       await signInWithEmailAndPassword(getAuth(), currentUser.email, currentPwd);
//       await updatePassword(getAuth().currentUser, newPwd);
//     },
//     [currentUser]
//   );

//   return {
//     currentUser,
//     loading,
//     saving,
//     error,
//     // state
//     mobile, setMobile,
//     address, setAddress,
//     family, setFamily,
//     // actions
//     saveContactAddress,
//     addFamilyMember,
//     removeFamilyMember,
//     changePassword,
//     // helpers
//     computeAgeFromDOB,
//   };
// }

// src/hooks/useResidentProfile.js
import { useEffect, useMemo, useState, useCallback } from "react";
import { doc, onSnapshot, updateDoc } from "firebase/firestore";
import { getAuth, onAuthStateChanged, signInWithEmailAndPassword, updatePassword } from "firebase/auth";
import { db } from "../firebase";

// Change this if residents are stored under /residents/{uid}
const RESIDENTS_COLLECTION = "users";

const emptyAddress = { line1: "", line2: "", city: "", state: "", zip: "" };

function computeAgeFromDOB(dobStr) {
  if (!dobStr) return undefined;
  const dob = new Date(dobStr);
  if (Number.isNaN(dob.getTime())) return undefined;
  const today = new Date();
  let age = today.getFullYear() - dob.getFullYear();
  const m = today.getMonth() - dob.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) age--;
  return age;
}

export function useResidentProfile({ collection = RESIDENTS_COLLECTION } = {}) {
  const auth = useMemo(() => getAuth(), []);
  const [currentUser, setCurrentUser] = useState(null);

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const [mobile, setMobile] = useState("");
  const [address, setAddress] = useState(emptyAddress);
  const [family, setFamily] = useState([]);

  // NEW: profile name + email + unit (block/flat)
  const [profileName, setProfileName] = useState("");
  const [email, setEmail] = useState("");
  const [unit, setUnit] = useState({ blockName: "", flatLabel: "" });

  // Track auth state
  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => setCurrentUser(u || null));
    return () => unsub();
  }, [auth]);

  // Firestore ref
  const userRef = useMemo(() => {
    const uid = currentUser?.uid;
    return uid ? doc(db, collection, uid) : null;
  }, [currentUser, collection]);

  // Subscribe to user profile
  useEffect(() => {
    if (!userRef) {
      setLoading(false);
      return;
    }
    setLoading(true);
    setError("");

    const unsub = onSnapshot(
      userRef,
      (snap) => {
        const data = snap.data() || {};

        // hydrate common fields
        setMobile(data?.profile?.mobile || data?.phone || "");
        setAddress({
          line1: data?.profile?.address?.line1 || "",
          line2: data?.profile?.address?.line2 || "",
          city:  data?.profile?.address?.city  || "",
          state: data?.profile?.address?.state || "",
          zip:   data?.profile?.address?.zip   || "",
        });
        const fam = Array.isArray(data?.family) ? data.family : [];
        setFamily(fam);

        // NEW: name/email/unit
        setProfileName(
          data?.profile?.name ||
          data?.fullName ||
          data?.name ||
          currentUser?.displayName ||
          currentUser?.email ||
          "Resident"
        );
        setEmail(currentUser?.email || data?.email || "");
        setUnit({
          blockName: data?.unit?.blockName || "",
          flatLabel: data?.unit?.flatLabel || "",
        });

        setLoading(false);
      },
      (err) => {
        console.error("useResidentProfile snapshot error:", err);
        setError(err?.message || "Failed to load profile.");
        setLoading(false);
      }
    );
    return () => unsub();
  }, [userRef, currentUser]);

  // Save contact/address
  const saveContactAddress = useCallback(async () => {
    if (!userRef) return;
    setSaving(true);
    setError("");
    try {
      await updateDoc(userRef, {
        "profile.mobile": mobile,
        "profile.address": {
          line1: address.line1?.trim() || "",
          line2: address.line2?.trim() || "",
          city:  address.city?.trim()  || "",
          state: address.state?.trim() || "",
          zip:   address.zip?.trim()   || "",
        },
      });
    } catch (err) {
      console.error("saveContactAddress error:", err);
      setError(err?.message || "Failed to save contact & address.");
    } finally {
      setSaving(false);
    }
  }, [userRef, mobile, address]);

  // Add family member (with optional dob/age)
  const addFamilyMember = useCallback(
    async (name, relationship, dob, ageInput) => {
      if (!userRef) return;
      if (!name?.trim() || !relationship?.trim()) {
        setError("Please provide both name and relationship.");
        return;
      }
      const computedAge = dob ? computeAgeFromDOB(dob) : undefined;
      const finalAge = computedAge ?? (Number.isFinite(Number(ageInput)) ? Number(ageInput) : undefined);

      setSaving(true);
      setError("");
      try {
        const id = `${Date.now()}-${Math.random().toString(16).slice(2)}`;
        const next = [
          ...family,
          {
            id,
            name: name.trim(),
            relationship: relationship.trim(),
            ...(dob ? { dob } : {}),
            ...(finalAge ? { age: finalAge } : {}),
          },
        ];
        await updateDoc(userRef, { family: next });
        setFamily(next);
      } catch (err) {
        console.error("addFamilyMember error:", err);
        setError(err?.message || "Failed to add family member.");
      } finally {
        setSaving(false);
      }
    },
    [userRef, family]
  );

  // Remove family member
  const removeFamilyMember = useCallback(
    async (id) => {
      if (!userRef) return;
      setSaving(true);
      setError("");
      try {
        const next = family.filter((m) => m.id !== id);
        await updateDoc(userRef, { family: next });
        setFamily(next);
      } catch (err) {
        console.error("removeFamilyMember error:", err);
        setError(err?.message || "Failed to remove family member.");
      } finally {
        setSaving(false);
      }
    },
    [userRef, family]
  );

  // Change password (reauth required)
  const changePassword = useCallback(
    async (currentPwd, newPwd) => {
      if (!currentUser?.email) {
        throw new Error("Your account has no email; password change not available.");
      }
      if (!currentPwd || !newPwd) {
        throw new Error("Please enter current and new password.");
      }
      if (newPwd.length < 6) {
        throw new Error("New password must be at least 6 characters.");
      }
      await signInWithEmailAndPassword(getAuth(), currentUser.email, currentPwd);
      await updatePassword(getAuth().currentUser, newPwd);
    },
    [currentUser]
  );

  return {
    currentUser,
    loading,
    saving,
    error,
    // state
    mobile, setMobile,
    address, setAddress,
    family, setFamily,
    // NEW exposed fields
    profileName,
    email,
    unit,
    // actions
    saveContactAddress,
    addFamilyMember,
    removeFamilyMember,
    changePassword,
    // helper
    computeAgeFromDOB,
  };
}
